import { React, useState, useRef } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import PasswordRoundedIcon from '@mui/icons-material/PasswordRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import '../css/pdfDecrypt.css';

const DecryptPDF = () => {
    const [cc, setCC] = useState('');
    const [contaEnergia, setContaEnergia] = useState(null);
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    const contaRef = useRef(null);

    async function submitDecryptPDF (e) {
        e.preventDefault();
        setIsSubmit(true);

        const formData = new FormData();
        formData.append('cc', cc);
        formData.append('password', password);
        formData.append('contaEnergia', contaEnergia);

        try {
            const response = await fetchFlask('saveDecryptedPDF', formData);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setCC('');
                setPassword('');
                setContaEnergia(null);
                if (contaRef.current) {
                    contaRef.current.value = '';
                }
            }
        } finally {
            setIsSubmit(false);
        }
    }

    const fileName = contaEnergia?.name || '';
    const completedFields = [cc, password, contaEnergia].filter(Boolean).length;

    return (
        <Box className='mainBox pdf-decrypt-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Decriptar PDF de Conta de Energia
            </PageHeader>

            <form action='' method='POST' id='pdfDecryptform' onSubmit={submitDecryptPDF} className='pdf-decrypt-layout'>
                <Box className='pdf-decrypt-workspace'>
                    <Box className='pdf-decrypt-intro'>
                        <Box>
                            <h2>Remoção de senha da conta de energia</h2>
                        </Box>
                    </Box>

                    <Box className='pdf-decrypt-panel'>
                        <Box className='pdf-decrypt-section-heading'>
                            <Inventory2RoundedIcon />
                            <Box>
                                <span>Etapa 1</span>
                                <strong>Conta contrato</strong>
                            </Box>
                        </Box>

                        <Box className='pdf-decrypt-input-strip'>
                            <BadgeRoundedIcon />
                            <TextField
                                required
                                label='Conta Contrato'
                                value={cc}
                                onChange={(e) => setCC(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box className='pdf-decrypt-panel'>
                        <Box className='pdf-decrypt-section-heading'>
                            <PasswordRoundedIcon />
                            <Box>
                                <span>Etapa 2</span>
                                <strong>Senha do arquivo</strong>
                            </Box>
                        </Box>

                        <Box className='pdf-decrypt-input-strip'>
                            <LockOpenRoundedIcon />
                            <TextField
                                required
                                label='Senha'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box className='pdf-decrypt-panel'>
                        <Box className='pdf-decrypt-section-heading'>
                            <FileUploadRoundedIcon />
                            <Box>
                                <span>Etapa 3</span>
                                <strong>Conta de energia</strong>
                            </Box>
                        </Box>

                        <Box className='pdf-decrypt-upload-strip'>
                            <PictureAsPdfRoundedIcon />
                            <Box>
                                <span>Arquivo aceito</span>
                                <strong>PDF</strong>
                            </Box>
                            <TextField
                                required
                                type='file'
                                size='small'
                                inputRef={contaRef}
                                inputProps={{ accept: 'application/pdf, image/*' }}
                                onChange={(e) => setContaEnergia(e.target.files[0])}
                            />
                        </Box>
                    </Box>
                </Box>

                <Box className='pdf-decrypt-summary'>
                    <Box className='pdf-decrypt-summary-header'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da decriptação</strong>
                        </Box>
                    </Box>

                    <Box className='pdf-decrypt-summary-list'>
                        <Box>
                            <span>Conta contrato</span>
                            <strong className={!cc ? 'is-empty' : undefined}>{cc || 'Não informada'}</strong>
                        </Box>
                        <Box>
                            <span>Senha</span>
                            <strong className={!password ? 'is-empty' : undefined}>{password ? 'Informada' : 'Não informada'}</strong>
                        </Box>
                        <Box>
                            <span>Arquivo</span>
                            <strong className={!fileName ? 'is-empty' : undefined}>{fileName || 'Não selecionado'}</strong>
                        </Box>
                    </Box>

                    <Box className='pdf-decrypt-attention'>
                        <RuleRoundedIcon />
                        <p>
                            Confira a conta contrato e o arquivo antes de enviar. O processo salvará a versão sem senha.
                        </p>
                    </Box>

                    <Box className='pdf-decrypt-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/3 preenchidos</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<LockOpenRoundedIcon />}>
                        Decriptar PDF
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default DecryptPDF;
